import type {AreaUnit} from '@src/constants/measureUnits.ts';
import useSettingsStore from '@src/stores/useSettingsStore.ts';
import formatArea from '@src/utils/formatArea.ts';

type AreaIndicatorProps = {
  // The value in square meters
  squareMeters: number;
  // The unit to display the area in. This should generally be left
  // blank so that it uses the user's preference
  unit?: AreaUnit | string;
};

const AreaIndicator = ({squareMeters, unit}: AreaIndicatorProps) => {
  const settingsUnit = useSettingsStore(state => state.measurement.areaUnit);
  const displayUnit = unit || settingsUnit;

  return formatArea(squareMeters, displayUnit);
};

export default AreaIndicator;
